import { Navigate, Outlet } from 'react-router-dom';

import { useShell } from '../shell/use-shell.js';
import { NoGameEmptyState } from '../shell/empty-states/no-game-empty-state.js';

// Wrapper that renders for any /s/:studioShortId/g/:gameShortId/* route. Validates
// that the slug matches a game on the active studio; otherwise falls back to
// the studio root so the user lands on something coherent rather than a 404.
export function GameSection(): JSX.Element {
  const { activeStudio, activeGame, games, loading } = useShell();

  if (loading) return <></>;

  if (activeGame === null) {
    if (games.length === 0) return <NoGameEmptyState />;
    return <Navigate to={`/s/${activeStudio.shortId}`} replace />;
  }

  return <Outlet />;
}
